import { render, staticRenderFns } from "./QuestionPlanAdd.vue?vue&type=template&id=52cfbb93&scoped=true&"
import script from "./QuestionPlanAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfbb93",
  null
  
)

export default component.exports